import React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { SubSectionHeader } from '../shared/SubSectionHeader';
import { FormField } from '../shared/FormField';
import classes from '../../bidAnalysisTemplate.module.scss';

interface CommercialPricingItem {
  modelWac?: string | number;
  lowWac?: string | number;
  tc0704Price?: string | number;
  tc0704Vendor?: string;
}

interface CommercialPriceRankingSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  commercialPricing: CommercialPricingItem[];
  templateType?: string; // 'mas' | 'nc' - to distinguish between MAS and NC templates
  formData?: any; // Form data for MAS and NC template fields
  onFieldChange?: (field: string, value: any) => void;
  onFieldBlur?: (field: string, value: any) => void;
  onFieldKeyDown?: (field: string, e: React.KeyboardEvent) => void;
}

export const CommercialPriceRankingSection: React.FC<CommercialPriceRankingSectionProps> = ({
  isExpanded,
  onToggle,
  commercialPricing: _commercialPricing,
  templateType,
  formData,
  onFieldChange,
  onFieldBlur,
  onFieldKeyDown,
}) => {
  const isNC = templateType === 'nc';

  return (
    <div className={classes.subSection}>
      <SubSectionHeader title="Commercial Pricing" isExpanded={isExpanded} onToggle={onToggle} />
      {isExpanded && (
        <div className={classes.subSectionContent}>
          <div className={classes.formGrid3}>
            <FormField label="Mode WAC">
              <InputNumber
                value={formData?.modeWac != null ? parseFloat(formData.modeWac) : null}
                onValueChange={e => onFieldChange && onFieldChange('modeWac', e.value)}
                onBlur={e => onFieldBlur && onFieldBlur('modeWac', e)}
                onKeyDown={e => onFieldKeyDown?.('modeWac', e)}
                placeholder="$"
                mode="decimal"
                minFractionDigits={2}
                maxFractionDigits={2}
                min={0}
              />
            </FormField>
            <FormField label="Low WAC">
              <InputNumber
                value={formData?.lowWac != null ? parseFloat(formData.lowWac) : null}
                onValueChange={e => onFieldChange && onFieldChange('lowWac', e.value)}
                onBlur={e => onFieldBlur && onFieldBlur('lowWac', e)}
                onKeyDown={e => onFieldKeyDown?.('lowWac', e)}
                placeholder="$"
                mode="decimal"
                minFractionDigits={2}
                maxFractionDigits={2}
                min={0}
              />
            </FormField>
            <FormField label="Top RX Price">
              <InputNumber
                value={formData?.topRxPrice != null ? parseFloat(formData.topRxPrice) : null}
                onValueChange={e => onFieldChange && onFieldChange('topRxPrice', e.value)}
                onBlur={e => onFieldBlur && onFieldBlur('topRxPrice', e)}
                onKeyDown={e => onFieldKeyDown?.('topRxPrice', e)}
                placeholder="$"
                mode="decimal"
                minFractionDigits={2}
                maxFractionDigits={2}
                min={0}
              />
            </FormField>
            <FormField label="Top RX Vendor">
              <InputText
                value={formData?.topRxVendor || ''}
                onChange={e => onFieldChange && onFieldChange('topRxVendor', e.target.value)}
                onBlur={e => onFieldBlur && onFieldBlur('topRxVendor', e.target.value)}
                placeholder="Enter vendor name"
              />
            </FormField>
            {isNC && (
              <>
                <FormField label="Cost Plus Price">
                  <InputNumber
                    value={
                      formData?.costPlusPrice != null ? parseFloat(formData.costPlusPrice) : null
                    }
                    onValueChange={e => onFieldChange && onFieldChange('costPlusPrice', e.value)}
                    onBlur={e => onFieldBlur && onFieldBlur('costPlusPrice', e)}
                    onKeyDown={e => onFieldKeyDown?.('costPlusPrice', e)}
                    placeholder="$"
                    mode="decimal"
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    min={0}
                  />
                </FormField>
                <FormField label="NADAC Price">
                  <InputNumber
                    value={formData?.nadacPrice != null ? parseFloat(formData.nadacPrice) : null}
                    onValueChange={e => onFieldChange && onFieldChange('nadacPrice', e.value)}
                    onBlur={e => onFieldBlur && onFieldBlur('nadacPrice', e)}
                    onKeyDown={e => onFieldKeyDown?.('nadacPrice', e)}
                    placeholder="$"
                    mode="decimal"
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    min={0}
                  />
                </FormField>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
